import React from "react";
import WalletCard from "./wallet_card/WalletCard";
import RankCard from "./rank_card/RankCard";
import "./WalletRank.css";
export default function WalletRank() {
  return (
    <section className="wallet-rank-section">
      <div className="container">
        <div className="row px-lg-5 g-3 align-items-stretch">
          <div className="col-md-6 wallet">
            <h4>Wallet & Earnings</h4>
            <WalletCard />
          </div>

          <div className="col-md-6 rank">
            <h4>Rank & Rewards</h4>
            <RankCard />
          </div>
        </div>
      </div>
    </section>
  );
}
